import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'index',
    props: (route) => ({ solution: route.query.solution, termId: route.query.termId, search: route.query.search }),
    component: () => import('../views/Index.vue')
  },
  {
    path: '/select',
    name: 'select',
    props: true,
    component: () => import('../views/Select.vue')
  },
  {
    path: '/corporate',
    name: 'corporate',
    props: true,
    component: () => import('../views/CorporateForm.vue')
  },
  {
    path: '/employee',
    name: 'employee',
    props: true,
    component: () => import('../views/EmployeeForm.vue')
  },
  {
    path: '/search',
    name: 'search',
    props: true,
    component: () => import('../views/SearchForm.vue')
  },
  {
    path: '/terms',
    name: 'terms',
    props: true,
    component: () => import('../views/Terms.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  next()
})

export default router
